import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const getMediaGridV2 = pageType => gql`
  fragment ${pageType}_Media_grid_v2 on ${pageType}BodyMedia_grid_v2 {
    type
    label
    variation {
      variation: __typename
      ... on ${pageType}BodyMedia_grid_v2Default {
        primary {
          title
          description
        }
        items {
          image
          subtitle
          link {
            ...documentLink
            ...externalLink
          }
        }
      }
      ... on ${pageType}BodyMedia_grid_v2Video {
        primary {
          title
          description
        }
        items {
          video
        }
      }
      ... on ${pageType}BodyMedia_grid_v2Internalvideo {
        primary {
          title
          description
        }
        items {
          internal_video {
            ...externalLink
            ... on _FileLink {
              name
              url
            }
          }
          autoplay
        }
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;
